import { render } from "./Redaktionen.vue?vue&type=template&id=8542d5f0"
import script from "./Redaktionen.vue?vue&type=script&lang=js"
export * from "./Redaktionen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__